import React from 'react';
import { Button } from '@ui';
import { translate } from '@utils/i18n';
import { NAMESPACE, addField, removeField, updateField } from './fieldDefinitionsUtils';
import FieldDefinitionRow from './FieldDefinitionRow';
import './FieldDefinitionsBuilderStyles.scss';
export default function FieldDefinitionsBuilder({ fieldDefinitions, onChange, onValidationChange, translationLanguages = [] }) {
    const [validationErrors, setValidationErrors] = React.useState({});
    React.useEffect(() => {
        const hasErrors = Object.keys(validationErrors).length > 0;
        onValidationChange === null || onValidationChange === void 0 ? void 0 : onValidationChange(hasErrors);
    }, [validationErrors, onValidationChange]);
    const handleAddField = () => {
        onChange(addField(fieldDefinitions));
    };
    const handleRemoveField = (index) => {
        onChange(removeField(fieldDefinitions, index));
    };
    const handleFieldChange = (index, updates) => {
        onChange(updateField(fieldDefinitions, index, updates));
    };
    const handleValidationError = (index, error) => {
        setValidationErrors((prev) => {
            if (error) {
                return Object.assign(Object.assign({}, prev), { [index]: error });
            }
            const newErrors = Object.assign({}, prev);
            delete newErrors[index];
            return newErrors;
        });
    };
    return (React.createElement("div", { className: "field-definitions-builder" },
        fieldDefinitions.map((field, index) => (React.createElement(FieldDefinitionRow, { translationLanguages: translationLanguages, key: index, field: field, onFieldChange: (updates) => handleFieldChange(index, updates), onRemove: () => handleRemoveField(index), externalError: validationErrors[index], onValidationError: (error) => handleValidationError(index, error) }))),
        React.createElement(Button, { variant: "highlighted", onClick: handleAddField }, translate('add_field', { namespace: NAMESPACE }))));
}
// Re-export validation utility for backward compatibility
export { validateFieldDefinitions } from './fieldDefinitionsValidation';
